module.exports = __webpack_public_path__ + "static/img/alarm-light-top.94e1b52a.png";